import styled from "styled-components";

export const Styles = styled.div`
  /* display: flex;
  flex-direction: column;
  gap: 1.5rem;
  height: inherit; */
`;